import { DateTime } from 'luxon'

export const minusOneDay = (dateStr) => DateTime.fromISO(dateStr).minus({ days: 1 }).toFormat('yyyy-MM-dd')

/** Mirrors `CalendarDurationsUtils.calculateVacationDays` on the backend */
export const rowCount = (row, saturdaysCalculatedAsHoliday = true) => {
	if (row.causeCode === 'FLEXI' || row.causeCode === 'HOURS') {
		if (row.startDate && row.endDate && row.dayHours) {
			const start = DateTime.fromJSDate(row.startDate)
			const end = DateTime.fromJSDate(row.endDate)

			const dayCount = Math.floor(end.diff(start, 'days').days) + 1
			return row.dayHours * dayCount
		}
	} else {
		if (!row.startDate || !row.endDate) return 0
		const start = DateTime.fromJSDate(row.startDate)
		const end = DateTime.fromJSDate(row.endDate)
		let count = 0
		let current = start
		while (current <= end) {
			const dow = current.weekday // Luxon: 1=Mon ... 6=Sat, 7=Sun
			if (dow < 6) {
				count++ // Mon–Fri always counted
			} else if (dow === 6 && saturdaysCalculatedAsHoliday) {
				count++ // Saturday counted only when setting is on
			}
			// Sunday never counted
			current = current.plus({ days: 1 })
		}
		return count
	}
	return 0
}
